import axios from 'axios';
import { toast } from 'react-toastify';
import EventBus from 'Utils/EventBus';
import { token as localStorageToken } from 'Utils/envLoader';
import { useUserStore } from 'Store/userStore';

//interceptor add header token
axios.interceptors.request.use(
    (config) => {
        // Do something before request is sent
        useUserStore.getState().setLoadingTrue();
        const token = localStorage.getItem(localStorageToken);
        config.headers = {
            Authorization: `Bearer ${token}`,
        };
        return config;
    },
    (error) => {
        // Do something with request error
        useUserStore.getState().setLoadingFalse();
        return Promise.reject(error);
    },
);

//interceptor handle 500, 401r
axios.interceptors.response.use(
    function (response) {
        useUserStore.getState().setLoadingFalse();
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // console.log('interceptor error!');

        if (error.response && error.response.status === 401) {
            // window.location = "/login";
            // localStorage.removeItem(localStorageToken);
            EventBus.dispatch('logout');
            toast.error('Unauthorized: please login!');
        }

        if (error.response.status === 500) {
            toast.dark('ERROR: server error!');
        }

        useUserStore.getState().setLoadingFalse();
        return Promise.reject(error);
    },
);

axios.defaults.withCredentials = true;

const http = {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    patch: axios.patch,
};

export default http;
